<template>
    <div class="card shadow-sm border-0 mb-3">
        <div class="card-body p-4">
            <div class="row">

                <div class="col">
                    <div class="d-flex align-items-start">
                        <router-link 
                            :to="{ path: '/mypools/'+ pool.pool_id}" 
                            tag="h5" 
                            class="font-weight-bold pool_name">
                            {{ pool.name }}
                        </router-link>
                        <!-- <h5 class="font-weight-bold">{{ pool.name }} </h5> -->
                        <small class="ml-auto">
                            <!-- <a href=""><span class="fas fa-share-alt fa-sm"></span>Share</a> -->
                            <span class="badge " :class="poolStatusClass"> {{ isPoolClosed ? 'Closed' :'Active'}} </span>
                        </small>
                        
                    </div>
                    <div class="d-flex mb-2">
                        <p class="p-0 mb-1">{{ pool.description }}</p>
                    </div>
                    <div class="row no-gutters">
                        <div class="col-lg-3 col-md-6">
                            <div class="">
                                <small class="my-1 py-0 text-muted">Collection Amount</small>
                                <h5 class="font-weight-bold mt-0  py-0">&#8358;{{ pool.total_amount | moneyformat }}</h5>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div>
                                <small class="my-1 py-0 text-muted">Received</small>
                                <h5 class="font-weight-bold text-success mt-0 py-0">&#8358;{{ pool.contributed_amount | moneyformat }}</h5>
                            </div>
                        </div>
                        <div class="col-lg-3 col-md-6">
                            <div class="">
                                <small class="my-1 py-0 text-muted">Contribution Deadline</small>
                                <h5 class="font-weight-bold mt-0  py-0">{{ pool.contribution_deadline | dayDateFormat }}</h5>
                            </div>

                        </div>
                        <div class="col-lg-2 col-md-6">
                            <div>
                                <small class="my-1 py-0 text-muted">Contributions</small>
                                <h5 class="font-weight-bold mt-0  py-0">{{ `${pool.contributions}/${pool.member_count}` }}</h5>
                            </div>

                        </div>
                        <!-- <div class="col-lg-1">
                            <span class="fa fa-circle fa-sm"></span>{{ pool.pool_status }}
                        </div> -->

                    </div>

                    <div class="mt-4 d-md-flex">
                        <div >
                            <router-link 
                                :to="{ path: '/mypools/'+ pool.pool_id}" 
                                tag="button" 
                                class="btn btn-light btn-sm mr-3">
                                Manage
                            </router-link>
                            <!-- <button class="btn btn-link btn-sm " @click=deletePool(pool.pool_id)>Share </button> -->
                            <!-- <a class="btn btn-link btn-sm" href="">Share </a> -->
                            <a href="#" class="btn btn-link btn-sm text-dark" data-toggle="modal" data-target="#exampleModal">
                               <span class="fa fa-share-alt"></span> Share
                            </a>
                        </div>
                        <div class="ml-auto mt-2">
                            <small class="ml-auto text-muted"> 
                                {{ pool.updated_at | dayDateFormat }}
                            </small>
                        </div>
                    </div>

                </div>
            </div>

        </div>
        <!-- social share -->
        <social-share :poolLink="poolLink"></social-share>

    </div>
</template>

<script>
import SocialShare from '@/components/SocialShare'

export default {
    props: ['pool'],

    components: {
        SocialShare
    },

    computed: {
        poolStatusClass() {
            const { pool_status } =  this.pool;

            return {
                'badge-success': pool_status == 'created' || 'active',
                'badge-danger': pool_status == 'closed' 
            }
        },
        isPoolClosed() {
            return this.pool.pool_status == 'closed' ? true : false;
        },
        poolLink() {
            return window.location.origin + '/pool/share/'+ this.pool.pool_id
        },
    },
    methods: {
        async deletePool(pool_id) {
            try {
                const pool = await axios.post('/pool/delete', { pool_id: pool_id });

                console.log(pool);
            } catch (error) {
                
            }
        }
    }

}
</script>

<style>
.pool_name {
    cursor: pointer;
}
.pool_name:hover {
    color: #2f073d;
}

</style>